/** A group can be as small as one person. Mirrors the server's rule. */
export const MIN_GROUP_SIZE = 1;
export const MAX_GROUP_SIZE = 20;

/** A member as their own therapist sees them. */
export interface GroupMember {
    id: string;
    first_name: string;
    last_name: string;
    contact_email?: string | null;
    center_id?: string | null;
    consent_ai_analysis: boolean;
}

export interface GroupPatient {
    id: string;
    therapist_id: string;
    display_name: string | null;
    members: GroupMember[];
    /** Every member's record was deleted and the group has nobody left. */
    below_minimum: boolean;
    /** Every member is the centre's. A group is never split between the two. */
    held_by_center: boolean;
    created_at?: string | null;
}

export interface CreateGroupPatientDTO {
    patient_ids: string[];
    display_name?: string;
}

/** What a group is called on a list or a header, name or no name. */
export function groupLabel(group: Pick<GroupPatient, "display_name" | "members">): string {
    return group.display_name || group.members.map((member) => member.first_name).join(", ");
}
